angular.module('clientDashboardApp').controller('CustomProvidersCtrl', function($scope, $uibModal, customProvidersService) {
  $scope.customProviders = []
  $scope.newCustomProvider = ""
  $scope.addProviderErrorMessages = []

  customProvidersService
    .get()
    .then(resp => {
      $scope.customProviders = resp.data.contentProviders
    })

  const createCustomProvider = (name) => ({
    name,
  })

  const validateCustomProvider = (name) => {
    const errors = []

    if (name.length < 1) {
      errors.push("Must specify custom provider name.")
    }
    if ($scope.customProviders.find(x => x.name == name) !== undefined) {
      errors.push("A custom provider with this name already exists.")
    }
    if (name !== name.toUpperCase()) {
      errors.push("A custom provider name must be all uppercase.")
    }
    if (name.match(/^[a-z0-9/\-/\s]+$/i) == null) {
      errors.push("Unable to add content provider, non-alphanumeric characters are prohibited.")
    }
    return errors
  }

  $scope.addCustomProvider = (newCustomProviderName) => {
    const validationErrors = validateCustomProvider(newCustomProviderName)
    $scope.addProviderErrorMessages = validationErrors

    if (validationErrors.length < 1) {
      $scope.customProviders.push(
        createCustomProvider(newCustomProviderName)
      )
      customProvidersService.update($scope.customProviders)
    }
  }

  const deleteProvider = (index) => {
    $scope.customProviders.splice(index, 1)
    customProvidersService.update($scope.customProviders)
  }

  $scope.displayDeleteConfirmation = (index) => {
    $scope.confirmSentimentChange = () => {
      deleteProvider(index)
    }

    $scope.confirmSentimentText = 'Are you sure you want to delete this provider?'
    $scope.confirmText = 'Yes, please delete'
  }

  $scope.hidePopovers = () => $("body").click()

  $scope.openContentProviderIconImageUploadModal = (customProvider) => {
    $uibModal.open({
      template: require('../../../common/imageUpload/imageUploadModal.html'),
      size: 'md',
      controller: "ImageUploadModalCtrl",
      windowClass: "image-upload-modal",
      resolve: {
        imageType: () => "ContentProviderIcon",
        preventSave: () => false,
        accountId: () => "", // TODO - not sure why this is necessary
        imageUploadEndpoint: () => "/v5/contentProviders/icon/upload",
        afterSaveCallback: () => (uploadedImageUrl) => {
          customProvider.imageUrl = uploadedImageUrl
          customProvidersService.update($scope.customProviders)
        }
      }
    })
  }
})
